import React, { useState } from "react";
import { Fab, Stack, TextField, Modal, Backdrop, Fade, Box } from "@mui/material";
import styled from "styled-components";
import LoginIcon from "@mui/icons-material/Login";
import { T } from "../../../lib/types/common";
import { Messages } from "../../../lib/config";
import { LoginInput, MemberInput } from "../../../lib/types/member";
import MemberService from "../../services/MemberService";
import { sweetErrorHandling } from "../../../lib/sweetAlert";
import { useGlobals } from "../../hooks/useGlobal";

const modalSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const paperSx = {
  backgroundColor: "#fff",
  border: "2px solid #8B2635",
  boxShadow: 8,
  p: 2,
  borderRadius: 2,
  outline: "none",
};

const ModalImg = styled.img`
  width: 62%;
  height: 280px;
  object-fit: cover;
  object-position: center;
  border-radius: 10px;
  background: #2b0d13;
  margin-top: 9px;
  margin-left: 10px;
`;

interface AuthenticationModalProps {
  signupOpen: boolean;
  loginOpen: boolean;
  handleSignupClose: () => void;
  handleLoginClose: () => void;
}

export default function AuthenticationModal(props: AuthenticationModalProps) {
  const { signupOpen, loginOpen, handleSignupClose, handleLoginClose } = props;
  const [memberNick, setmemberNick] = useState<string>("");
  const [memberPhone, setMemberPhone] = useState<string>("");
  const [memberPassword, setMemberPassword] = useState<string>("");
  const { setAuthMember } = useGlobals();

  const handleUsername = (e: T) => setmemberNick(e.target.value);
  const handlePhone = (e: T) => setMemberPhone(e.target.value);
  const handlePassword = (e: T) => setMemberPassword(e.target.value);

  const handlePasswordKeyDown = (e: T) => {
    if (e.key === "Enter" && signupOpen) {
      handleSignupRequest().then();
    } else if (e.key === "Enter" && memberPassword !== "") {
      handleLoginRequest().then();
    }
  };

  const handleSignupRequest = async () => {
    try {
      const isFullfill =
        memberNick !== "" && memberPhone !== "" && memberPassword !== "";
      if (!isFullfill) throw new Error(Messages.error3);

      const signupInput: MemberInput = {
        memberNick,
        memberPhone,
        memberPassword,
      };

      const member = new MemberService();
      const result = await member.signup(signupInput);
      setAuthMember(result);
      handleSignupClose();
    } catch (err) {
      console.log(err);
      handleSignupClose();
      sweetErrorHandling(err).then();
    }
  };

  const handleLoginRequest = async () => {
    try {
      const isFullfill = memberNick !== "" && memberPassword !== "";
      if (!isFullfill) throw new Error(Messages.error3);

      const loginInput: LoginInput = {
        memberNick,
        memberPassword,
      };

      const member = new MemberService();
      const result = await member.login(loginInput);
      setAuthMember(result);
      handleLoginClose();
    } catch (err) {
      console.log(err);
      handleLoginClose();
      sweetErrorHandling(err).then();
    }
  };

  return (
    <div>
      <Modal
        open={signupOpen}
        onClose={handleSignupClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
        sx={modalSx}
      >
        <Fade in={signupOpen}>
          <Box sx={paperSx}>
            <Stack direction={"row"} sx={{ width: "800px" }}>
              <ModalImg src={"/img/library-1.jpg"} alt="BooClub library" />
              <Stack sx={{ marginLeft: "69px", alignItems: "center" }}>
                <h2>Signup Form</h2>
                <TextField
                  sx={{ marginTop: "7px" }}
                  label="username"
                  variant="outlined"
                  onChange={handleUsername}
                />
                <TextField
                  sx={{ my: "17px" }}
                  label="phone number"
                  variant="outlined"
                  onChange={handlePhone}
                />
                <TextField
                  label="password"
                  variant="outlined"
                  type="password"
                  onChange={handlePassword}
                  onKeyDown={handlePasswordKeyDown}
                />
                <Fab
                  sx={{ marginTop: "30px", width: "120px" }}
                  variant="extended"
                  color="primary"
                  onClick={handleSignupRequest}
                >
                  <LoginIcon sx={{ mr: 1 }} />
                  Signup
                </Fab>
              </Stack>
            </Stack>
          </Box>
        </Fade>
      </Modal>

      <Modal
        open={loginOpen}
        onClose={handleLoginClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
        sx={modalSx}
      >
        <Fade in={loginOpen}>
          <Box sx={paperSx}>
            <Stack direction={"row"} sx={{ width: "700px" }}>
              <ModalImg src={"/img/library-1.jpg"} alt="BooClub library" />
              <Stack
                sx={{
                  marginLeft: "65px",
                  marginTop: "25px",
                  alignItems: "center",
                }}
              >
                <h2>Login Form</h2>
                <TextField
                  label="username"
                  variant="outlined"
                  sx={{ my: "10px" }}
                  onChange={handleUsername}
                />
                <TextField
                  label="password"
                  variant="outlined"
                  type="password"
                  onChange={handlePassword}
                  onKeyDown={handlePasswordKeyDown}
                />
                <Fab
                  sx={{ marginTop: "27px", width: "120px" }}
                  variant="extended"
                  color="primary"
                  onClick={handleLoginRequest}
                >
                  <LoginIcon sx={{ mr: 1 }} />
                  Login
                </Fab>
              </Stack>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
